/**
 * This file handles all of the
 */

( function() {

	const $ = jQuery;

	const grid = $('#Programs');
	const loadMore = $('#LoadMore');
	const type = $('#ProgramType');
	const school = $('#School');
	const reset = $('#reset');

	loadMore.on('click', function(e) {
		getPrograms('filter_programs', false);
	});

	type.on('change', function(e) {
		getPrograms('filter_programs', true);
	});

	school.on('change', function(e) {
		getPrograms('filter_programs', true);
	});

	reset.on('click', function(e) {
		$('#ProgramType').prop('selectedIndex', 0).trigger('change');
		$('#School').prop('selectedIndex', 0).trigger('change');
	});

	/**
	 * Fetches programs via ajax
	 * @param {string} action
	 * @param {boolean} resetPage
	 */
	function getPrograms(action, resetPage) {

		// get current programType
		const typeVal = type.val();
		const schoolVal = school.val();

		// get next page offset
		const currentPage = parseInt(loadMore.attr('data-page'), 10) + 1;

		const data = {
			action,
			type: typeVal,
			school: schoolVal,
			paged: resetPage ? 1 : currentPage
		};

		$.ajax({
			method: 'POST',
			// eslint-disable-next-line no-undef
			url: ajax_object.ajax_url,
			data,
			success(resp) {

				$('#no-results').remove();

				const content = $(resp.html);
				const pageNum = resetPage ? 1 : data.paged;

				// Append the html to the container
				if(resetPage) {
					grid.html(content);
				} else {
					grid.append(content);
				}

				loadMore.attr('data-page', pageNum);

				// show no results message if there is no html
				if ('' === resp.html) {
					// eslint-disable-next-line no-undef
					grid.html('<div id="no-results">' + ajax_object.no_results + '</div>');
				}

				// if there are no more results to show, hide the load more button
				if (resp.max_num_pages === data.paged || 0 === resp.max_num_pages) {
					loadMore.hide();
				} else {
					loadMore.show();
				}

			},
			error(err) {
				console.log(err);
			}
		});

	}

}() );
